import { Injectable } from '@angular/core';
import { ConfigProvider } from "../../config-provider.service";
import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { ApiBaseService } from "../../common/providers/api-base-service";
import { Agenda } from "../../common/models/agenda";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { CurrentUser } from "../../common/providers/current-user";

@Injectable({providedIn: 'root'})
export class AgendaProvider {
    constructor(
        private api: ApiBaseService,
        private currentUser: CurrentUser,
    ) {
    }


    public getAthleteAgenda(organizationId: number, athleteUserId: number): Observable<Agenda> {
      return this.api.call('get',`organizations/${organizationId}/athletes/${athleteUserId}/agenda`, {}, this.currentUser.getAccessToken())
        .pipe(
          map((response: Agenda) => {
            return Agenda.fromAPI(response);
          }),
        );
    }



}
